export default {
  data() {
    return {
      isActiveDarkBlackCover: false,
      isActiveLightBlackCover: false,
      isActiveWhiteCover: false
    }
  },
  methods: {
    toggleDarkBlackCover() {
      this.isActiveDarkBlackCover = !this.isActiveDarkBlackCover
    },
    toggleLightBlackCover() {
      this.isActiveLightBlackCover = !this.isActiveLightBlackCover
    },
    toggleWhiteCover() {
      this.isActiveWhiteCover = !this.isActiveWhiteCover
    }
  }
}
